module.exports = __webpack_public_path__ + "static/img/deal_17.b37be3c1.png";